import { render, staticRenderFns } from "./extensionTool.vue?vue&type=template&id=5fed472b&scoped=true&"
import script from "./extensionTool.vue?vue&type=script&lang=js&"
export * from "./extensionTool.vue?vue&type=script&lang=js&"
import style0 from "./extensionTool.vue?vue&type=style&index=0&id=5fed472b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fed472b",
  null
  
)

export default component.exports